export enum SavingCardRewardTypes {
  Coupon = 0,
  Currency = 1
}
